export default {
  "theatre.update": "更新",
  "theatre.create": "スクリーン作成",
  "theatre.screen": "スクリーン",
  "theatre.entry": "入口",
  "theatre.exit": "出口",
  "theatre.stairs": "階段",
  "theatre.down": "スロープ",
  "theatre.seatType": "座席",
  "theatre.name": "スクリーン名",
  "theatre.description": "説明",
  "theatre.descriptionPlsInput": "説明を入力してください",
  "theatre.plsEnterTheatreName": "スクリーン名を入力してください",
  "theatre.plsEnterMovieName": "劇場名を入力してください",
  "theatre.vacancyStatus": "空席状況",
  "theatre.seatPlanSet": "座席表設定",

  "theatre.globalgroup.shownas":"表示",
  "theatre.globalgroup.color":"色",
  "theatre.globalgroup.vacant":"空席数",
  "theatre.seat.leager.vacant":"余裕あり",
  "theatre.seat.leager.ranout":"残りわずか",
  "theatre.seat.leager.filled":"満席",
  "theatre.seat.leager.notforsale":"販売対象外",
  "theatre.rowcode":"行コード",
  "theatre.columncode":"列コード",
  "theatre.alphabets":"英字",
  "theatre.numbers":"番号",
  "theatre.order":"順序",
  "theatre.order.alphabet.asc":"A ~ Z",
  "theatre.order.alphabet.desc":"Z ~ A",
  "theatre.order.numbers.asc":"1 ~ N",
  "theatre.order.numbers.desc":"N ~ 1",
  "theatre.seat.general":"一般席",
  "theatre.seat.vip":"VIP席",
  "theatre.seat.special":"特別席",
  "theatre.seat.wheelchair": "車椅子席",
  "theatre.seat.loversSeat": "ペアシート",
  "theatre.seat.stopsale":"非売席",
  "theatre.reset":"リセット",
  "theatre.numberof.rows":"行数",
  "theatre.numberof.col":"列数",
  "theatre.spacing.row":"行間隔",
  "theatre.spacing.col":"列間隔",
  "theatre.insert.row":"行を挿入",
  "theatre.insert.col":"列を挿入",
  "theatre.remove.seat":"座席を削除",
  "theatre.repair.seat":"修理中",

  "theatre.filmSet": "ムビチケ・TMS・シネマフォン連携設定",
  "theatre.screenCode": "スクリーンコード",
  "theatre.screenCodeHint": "※未設定の場合、TMS連携CSV・シネマフォン連携CSVのスクリーンIDは「0」で出力されます",

  "theatre.p.input": "入力してください",

  "theatre.delete.rowspan": "行を削除",
  "theatre.delete.column": "列を削除",
  "theatre.translate.left":"左へ移動",
  "theatre.translate.right": "右へ移動",
  "theatre.Other.Type": "設備",
  "theatre.Seating.level": "座席種類",
  "theatre.seat.windowSeat": "窓口専売席",
  "theatre.plsEnterHouseName": "劇場名を入力してください",
  "theatre.editSeatNumber": "座席番号を編集",
  "theatre.SeatNumberRepeat": "番号が既に存在しています",
  "theatre.displaySetting": "座席タイプ・レベル表示設定",
  "theatre.settingList": "設定一覧へ",
  "theatre.seatTypeSetting": "座席タイプ設定",
  "theatre.seatSettingAdd": "メッセージ追加"
};